"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Util = require("../Util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SECONDS_OF_MINUTE = 60;
var SECONDS_OF_HOUR = 60 * SECONDS_OF_MINUTE;
var SECONDS_OF_DAY = 24 * SECONDS_OF_HOUR;

function getRemaining(endTime) {
  var now = new Date().getTime();
  var diff = Math.round((endTime - now) / 1000);
  var days = Math.floor(diff / SECONDS_OF_DAY);
  var hours = Math.floor(diff % SECONDS_OF_DAY / SECONDS_OF_HOUR);
  var minutes = Math.floor(diff % SECONDS_OF_DAY % SECONDS_OF_HOUR / SECONDS_OF_MINUTE);
  var seconds = Math.round(diff % SECONDS_OF_DAY % SECONDS_OF_HOUR % SECONDS_OF_MINUTE);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    done: diff <= 0
  };
} // eslint-disable-next-line react/prop-types


function FixWidthNumber(_ref) {
  var number = _ref.number,
      label = _ref.label,
      _ref$length = _ref.length,
      length = _ref$length === void 0 ? 2 : _ref$length;
  var str = number.toString();

  while (str.length < length) {
    str = "0".concat(str);
  }

  var numbers = str.split('');
  return _react["default"].createElement("span", {
    className: "num-group"
  }, _react["default"].createElement("span", {
    className: "num-items"
  }, numbers.map(function (x, i) {
    return (// eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement("strong", {
        key: "num-".concat(i),
        className: "num-item"
      }, x)
    );
  })), _react["default"].createElement("span", {
    className: "num-label"
  }, label));
}

var CountDown = /*#__PURE__*/function (_react$default$Compon) {
  _inheritsLoose(CountDown, _react$default$Compon);

  var _super = _createSuper(CountDown);

  function CountDown(props) {
    var _this;

    var newProps = (0, _Util.mergeProps)(props, CountDown, ['dark', 'endTime', 'style']);
    _this = _react$default$Compon.call(this, newProps) || this;
    _this.state = getRemaining(newProps.endTime);
    _this.timer = null;
    return _this;
  }

  var _proto = CountDown.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.timer = setInterval(function () {
      var remaining = getRemaining(_this2.props.endTime);

      if (remaining.done) {
        clearInterval(_this2.timer);
        _this2.timer = null;
      }

      _this2.setState(remaining);
    }, 1000);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        dark = _this$props.dark,
        endTime = _this$props.endTime,
        rest = _objectWithoutProperties(_this$props, ["dark", "endTime"]);

    var _this$state = this.state,
        days = _this$state.days,
        hours = _this$state.hours,
        minutes = _this$state.minutes,
        seconds = _this$state.seconds;
    return _react["default"].createElement(Container, Object.assign({
      dark: dark
    }, rest), _react["default"].createElement(FixWidthNumber, {
      number: days,
      label: "D"
    }), _react["default"].createElement("span", {
      className: "num-sep"
    }, ":"), _react["default"].createElement(FixWidthNumber, {
      number: hours,
      label: "H"
    }), _react["default"].createElement("span", {
      className: "num-sep"
    }, ":"), _react["default"].createElement(FixWidthNumber, {
      number: minutes,
      label: "M"
    }), _react["default"].createElement("span", {
      className: "num-sep"
    }, ":"), _react["default"].createElement(FixWidthNumber, {
      number: seconds,
      label: "S"
    }));
  };

  return CountDown;
}(_react["default"].Component);

exports["default"] = CountDown;
CountDown.propTypes = {
  endTime: _propTypes["default"].number.isRequired,
  // endTime should be UTC
  dark: _propTypes["default"].bool,
  style: _propTypes["default"].object
};
CountDown.defaultProps = {
  dark: true,
  style: {}
};
var textBackground = "linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),\nlinear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5) 77%, rgba(0, 0, 0, 0.5))";

var Container = _styledComponents["default"].div.withConfig({
  displayName: "CountDown__Container",
  componentId: "i2a9gr-0"
})(["color:", ";font-size:50px;display:flex;flex-direction:row;justify-content:center;align-items:flex-start;.num-group{display:flex;flex-direction:column;justify-content:center;align-items:center;margin:0 60px;@media (max-width:", "px){margin:0 20px;}@media (max-width:", "px){margin:0;}.num-items{display:flex;flex-direction:row;}.num-item{display:inline-block;width:40px;height:60px;line-height:60px;background-image:", ";text-align:center;&:first-of-type{margin-right:10px;@media (max-width:", "px){margin:0;}}}.num-label{margin-top:20px;font-size:24px;color:", ";}}"], function (props) {
  return (0, _Util.getColor)(props);
}, function (props) {
  return props.theme.breakpoints.values.md;
}, function (props) {
  return props.theme.breakpoints.values.sm;
}, function (props) {
  return props.dark ? textBackground : 'none';
}, function (props) {
  return props.theme.breakpoints.values.sm;
}, function (props) {
  return (0, _Util.getColor)(props);
});